/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Commandmanp12Inputs */



/**
* | output |
* | --- |
* | "Manual command left/high pump" |
*
* @param {Br_History_Key_Commandmanp12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_commandmanp12 = /** @type {((inputs?: Br_History_Key_Commandmanp12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Commandmanp12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manual command left/high pump")
	return /** @type {LocalizedString} */ ("Commande manuelle pompe gauche/haute")
});
export { br_history_key_commandmanp12 as "br_history_key_commandManP1" }